import {StoreAction} from "@/store/actions";
import {RouterContext} from "@/router/router-context";

/**
 * Обновление информации о пользователе
 */
export default function refreshCurrentUser({to, next, store}: RouterContext) {
  if (!store.getters.currentUser) {
    store.dispatch('getCurrentUser')
      .then(_ => next());
  } else {
    next();
  }
}
